import { ref } from 'vue';
import { PhxTabs, PhxTabPanel } from '@phx-styleguides/rdu';
import createVueApp from '@phoenix/createVueApp';

document.querySelectorAll('.phoenix-tabs-group').forEach((el) => {
  const app = createVueApp({
    setup() {
      const value = ref(el.getAttribute('data-tabs-group-init'));
      return {
        value,
        orientation: 'horizontal',
        layout: 'stretch',
        tabButtonsIcon: undefined,
        goToTab: (id) => {
          value.value = id;
        },
        onChange: (id) => {
          value.value = id;
        },
      };
    },
  });
  app.component('PhxTabs', PhxTabs);
  app.component('PhxTabPanel', PhxTabPanel);
  app.mount(el);
});
